import { observer } from 'mobx-react-lite'
import { Alert, Button, Label, TextareaWithLabel, UploadDoc } from 'shared/ui'
import { PageDescription } from 'pages/settings/ui/PageDescription/PageDescription'
import { NextButton } from 'pages/settings/ui/NextButton/NextButton'
import { useRcsWizardContext } from 'pages/settings/pages/rcsV2/context/rcsWizardContext'
import { RcsWizardSteps } from 'pages/settings/pages/rcsV2/route/type'
import { UploadedFileCard } from 'pages/settings/pages/rcsV2/ui/UploadedFileCard/UploadedFileCard'

import styles from './styles.module.scss'

export const OptInMessageInfo = observer(() => {
  const {
    navigationStore,
    optInMessageInfoStore: {
      messageFlow,
      optInImage,
      optInImageError,
      optOut,
      messageFlowMinLength,
      messageFlowMaxLength,
      optOutMinLength,
      optOutMaxLength,
      isNextDisabled,
      setMessageFlow,
      setOptInImage,
      removeOptInImage,
      clearOptInImageError,
      setOptOut,
    },
  } = useRcsWizardContext()

  const onNext = () => {
    navigationStore.goToNextStep(RcsWizardSteps.optInMessageInfo)
  }

  return (
    <div className={styles.wrap}>
      <PageDescription>
        Provide examples of how users opt in, receive messages, and unsubscribe from your RCS
        campaigns.
      </PageDescription>

      <TextareaWithLabel
        className={styles.messageFlowField}
        classNameTextarea={styles.fieldText}
        value={messageFlow}
        onChange={setMessageFlow}
        limit={messageFlowMaxLength}
        minLimit={messageFlowMinLength}
        errorType='bottomText'
        name='description'
        placeholder='Describe how users discover your business and give consent to receive messages, such as filling out a form or checking an opt-in box on your website'
        labelProps={{
          marginBottom: 0,
          label: {
            text: 'Message flow and opt-in description',
            rightNode: <Button text='See example' size='small' typeBtn='informative' />,
          },
        }}
      />

      <Label
        marginTop={24}
        marginBottom={4}
        questionTooltipProps={{ type: 'description', label: 'Opt-in policy image' }}
        label={{
          text: 'Opt-in policy image',
          rightNode: <Button text='See example' size='small' typeBtn='informative' />,
        }}
      />

      {optInImageError && (
        <Alert
          item={{ title: optInImageError.title, desc: optInImageError.desc, type: 'error' }}
          onClose={clearOptInImageError}
          marginBottom={12}
        />
      )}

      <UploadDoc uploadTypeText='Acceptable file types: jpg, png' onChange={setOptInImage} />

      {optInImage && (
        <UploadedFileCard file={optInImage} type='image' onRemove={removeOptInImage} />
      )}

      <TextareaWithLabel
        className={styles.optOutField}
        classNameTextarea={styles.fieldText}
        value={optOut}
        onChange={setOptOut}
        limit={optOutMaxLength}
        minLimit={optOutMinLength}
        errorType='bottomText'
        name='description'
        placeholder='Explain how users can unsubscribe or stop receiving messages'
        labelProps={{
          marginBottom: 0,
          label: {
            text: 'Opt-out description',
            rightNode: <Button text='See example' size='small' typeBtn='informative' />,
          },
        }}
      />

      <NextButton text='Next' disabled={isNextDisabled} onClick={onNext} />
    </div>
  )
})
